import { render, staticRenderFns } from "./HeadsupVersion.vue?vue&type=template&id=ffce4152"
import script from "./HeadsupVersion.vue?vue&type=script&lang=js"
export * from "./HeadsupVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports